import React from "react";
import Image from "../../../elements/Image";
import { classNames } from "../../../../helpers/classNames";
import { Link } from "react-router-dom";
import NoImage from "../../../../assets/images/no-image-available.png";

const AnnouncementItem = ({ index, data }) => {
  return (
    <>
      <Link to={data?.link} className={classNames("relative block xls:flex items-center py-8 px-8 group", index % 2 === 0 ? "bg-chestnut-rose" : "bg-blue-zodiac")}>
        <div className="md:flex mb-8 xls:mb-0">
          {data?.date && (
            <div className="flex-shrink-0 w-48 flex flex-col items-left md:items-center justify-start md:justify-center text-white">
              {data?.date?.day && <div className="text-4xl sm:text-5xl xls:text-7xl xl:text-[86px] leading-none font-bold font-CanelaDeck">{data?.date?.day}</div>}
              {data?.date?.month && <div className="text-sm sm:text-base xls:text-xl xl:text-2xl font-semibold font-CanelaDeck">{data?.date?.month}</div>}
            </div>
          )}
          <div className="flex-shrink flex-grow space-y-4 pl-0 md:pl-11 lg:pl-16 pr-0 md:pr-11 lg:pr-16 2xl:pr-40 md:border-l border-white text-white py-4">
            {data?.title && <h2 className="text-2xl xls:text-3xl font-bold">{data?.title}</h2>}
            {data?.description && <div className="text-base xls:text-lg font-Gotham font-medium !leading-normal" dangerouslySetInnerHTML={{ __html: data?.description }} />}
          </div>
        </div>

        <div className="flex-shrink-0 xls:w-96">
          <div className="w-full lg:w-[700px] xls:w-full overflow-hidden flex xls:aspect-[4/3] bg-shades-03 mx-auto">
            <Image
              src={data?.image || NoImage}
              alt={""}
              effect="blur"
              classes={classNames("!transition-all duration-200", data?.image ? "object-cover group-hover:scale-110 " : "object-contain scale-[0.6]")}
            />
          </div>
        </div>
      </Link>
    </>
  );
};

export default AnnouncementItem;
